import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';

export const replaceSpacesToNbsp = (text: string) =>
  (text || '').replace(new RegExp(' ', 'g'), NO_BREAK_SPACE).replace(/-/g, '\u2011');
